<template>
    <modals-side-generic
    showSearchSlot
    :triggerClose="triggerClose"
    :title="t('modals.contacts.title')"
    :showFooter="showButtons"
    :buttonsFooterData="buttonsFooterData"
    @hideMe="emit('hideMe')">
        <!-- *********************************************
        *                    Search Bar                  *
        ********************************************** -->
        <template #top-search-area-slot>
            <input-search
            v-if="hasPermission"
            :params="{ placeholder: sendType === 'email' ? t('modals.contacts.searchPlaceholderEmail') : t('modals.contacts.searchPlaceholderSMS')}"
            :inputValue="searchValue"
            @input="searchValue = $event"
            @rightButtonClicked="searchValue = $event"/>
        </template>
        <!-- *********************************************
        *                  Contacts List                 *
        ********************************************** -->
        <contacts-list
        :sendType="sendType"
        :destinationValues="destinationValues"
        :searchValue="searchValue"
        :showOnlyBAIContacts="showOnlyBAIContacts"
        @hasPermission="hasPermission = $event"
        @contactSelected="emit('contactSelected', $event)"/>
    </modals-side-generic>
</template>

<script setup>
import ModalsSideGeneric from '@/components/generic/modals/side/Generic'
import InputSearch from '@/components/generic/inputs/Search'
import ContactsList from '@/components/generic/modals/side/contacts/ContactsList'

/* Vue */
import { ref } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['contactSelected'])

/* Props
@title {String} - text to display in title
@subTitle {String} - text to display in subTitle
@icon {String} - icon to display in header
@sendType {String} - send information type ['email'(default), 'sms']
@destinationValues {Array} - list of already selected contact values
@hasTabs {Boolean} - prop to show tabs
@showOnlyBAIContacts {Boolena} - prop to show only the BAI contacts
@triggerClose {Boolean} - prop to trigger close of filter modal so animation happens before our modal disapears
*/
const props = defineProps({
    title: String,
    subTitle: String,
    icon: String,
    sendType: { type: String, default: 'email' },
    destinationValues: Array,
    hasTabs: Boolean,
    showOnlyBAIContacts: Boolean,
    triggerClose: Boolean
})

const hasPermission = ref(false)
const searchValue = ref('')
</script>

<style lang="scss" scoped>
</style>
